<div class="footer-copyright">
  <div class="company-block" [innerHTML]="'COPYRIGHT_TEXT' | translate"></div>
  <a href="https://naveksoft.com" target="_blank" class="dev-block">
    <span class="dev-text" [innerHTML]="'DEVELOPER_TEXT' | translate"></span>
    <a class="dev-link is-block">
      <img
        class="dev-logo"
        src="./assets/img/logos/logo_navek_soft.png"
        alt="NavekSoft"
      />
    </a>
  </a>
  <p class="build-version">{{ buildInfo }}</p>
</div>
